import React from 'react';

export const pageMeta = {
  "name": "jQuery HTML",
  "link": "/javascript/jquery/html"
};

export default function JavascriptJqueryHtml() {
  return (
    <div className="p-6 max-w-3xl mx-auto">
      <h2 className="text-2xl font-semibold mb-2">jQuery HTML</h2>
      <p>Route: /javascript/jquery/html</p>
      <h3 className="mt-4 font-medium">sub_content</h3>
      <pre>{JSON.stringify(pageMeta, null, 2)}</pre>
    </div>
  );
}
